
import {
  defineComponent,
  defineAsyncComponent,
  computed,
  onMounted,
  ref,
  Component,
  watch,
} from "vue";
import { Notify, RadioGroup, CellGroup, Cell, Radio, Toast, List, PullRefresh } from "vant";

export default {
  name: "Plate",
  props: {
    list: {
      type: Array,
      default: ()=>[]
    },
    isLastPage: {
      type: Boolean,
      default: false
    },
    teacherListLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },

  components: {
    "van-radio-group": RadioGroup,
    "van-cell-group": CellGroup,
    "van-cell": Cell,
    "van-radio": Radio,
    "van-list": List,
    "van-pull-refresh": PullRefresh
  },
  setup(props: any, target: any) {
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false);
    const radio = ref(-1);

    onMounted(async () => {
      //const [err, data] = await Account.login({})
      // Notify('onMounteSSSd')
    });

    const loadRemote = ()=> {
      if(props.isLastPage){
        finished.value = true
      }
      target.emit('load')
    }

    const onRefresh = () => {
      finished.value = false
      target.emit('refresh')
    };

    watch(()=>props.teacherListLoading, (curr, prev)=>{
      if(curr === false && prev === true){
        if(props.isLastPage){
          finished.value = true
        }
        loading.value = false
        refreshing.value = false
      }
    })

    const onRadio = (item: any) => {
      if (!item.user_tel) return;
      //Toast.fail("没有手机号,不能被选中");
      // if (!tel)
      //   return Toast.fail(
      //     "被访人接受审批短信失败，本次预约无法通知对方！请通过其他方式预约被访人！"
      //   );
      radio.value = item.user_serial;
      target.emit("getSurveyedList", item);
    };

    return {
      radio,
      onRadio,
      loading,
      finished,
      loadRemote,
      refreshing,
      onRefresh
    };
  },
  methods: {}
};
